/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18next';

import { Button } from 'uikit/buttons';
import { SwitchInput } from 'uikit/inputs';
import { Tooltip } from 'uikit/tooltips';
import { Typo } from 'uikit/content';

import styles from '../styles/appHeaderActions.module.scss';

const AppHeaderActions = ({
  appHeaderActions,
}) => (
  <ul className={styles.element}>
    {appHeaderActions.map((action) => {
      const { hasTooltip, isToggle, tooltipText, ...other } = action;
      const { id } = action;
      const Element = hasTooltip ? Tooltip : 'li';

      const TooltipChildElement = Element === Tooltip ? 'span' : React.Fragment;

      return (
        <Element content={tooltipText} key={id} placement="right">
          {/* Tooltips require a span here otherwise it doesn't show when button is disabled */}
          <TooltipChildElement>
            {isToggle ? (
              <div className={styles.toggle}>
                <label htmlFor={id}>
                  <Typo variant="s03" weight="medium">
                    {action.text}
                  </Typo>
                </label>
                <SwitchInput
                  {...other}
                  text={action.isChecked ? i18n.t('on') : i18n.t('off')}
                  toggleId={id}
                />
              </div>
            ) : (
              <Button {...other} />
            )}
          </TooltipChildElement>
        </Element>
      );
    })}
  </ul>
);

AppHeaderActions.propTypes = {
  appHeaderActions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default React.memo(AppHeaderActions);
